export class CaptchaStateService {
  v2Resolved = false;
  v3Resolved = false;

  reset() {
    this.v2Resolved = false;
    this.v3Resolved = false;
  }
}

// tslint:disable-next-line:variable-name
export const CaptchaStateServiceFactory = () => new CaptchaStateService();

export const captchaStateService = CaptchaStateServiceFactory();
